export default "__VITE_ASSET__3edeffd1__"